var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"announcer",attrs:{"aria-live":"polite","aria-relevant":"additions"}},_vm._l((_vm.announcements),function(a){return _c('p',{attrs:{"role":"status"}},[_vm._v(_vm._s(a))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }